




















































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
	SensorType,
	SENSOR_OPTIONS,
	isRadar,
} from '@/pages/account/products/feed/models/sensor-config';

interface SensorConfig {
	label: string;
	unit: string;
}

const SENSOR_CONFIG: Record<SensorType, SensorConfig> = {
	strain: { label: 'Nominal Weight', unit: 't' },
	radar: { label: 'Nominal Volume', unit: 'L' },
};

@Component({})
export default class AddFeedTankModal extends Vue {
	@Prop({ required: true, type: Function })
	private createFeedTank!: (
		params:
			{ nominalVolume: number; name: string; sensorType: string }
	) => Promise<void>;

	@Prop({ required: true, type: Function })
	private onTankCreated!: () => Promise<void>;

	public name = '';
	public nominalValue = 0;
	public sensorType: SensorType = 'strain';

	public readonly sensorOptions = SENSOR_OPTIONS;

	// Computed from config
	public get config(): SensorConfig {
		return SENSOR_CONFIG[this.sensorType];
	}

	public get nominalLabel(): string {
		return this.config.label;
	}

	public get unit(): string {
		return this.config.unit;
	}

	public get placeholder(): string {
		return `Enter a nominal ${isRadar(this.sensorType) ? 'volume' : 'weight'}`;
	}

	public get inputStep(): string {
		return isRadar(this.sensorType) ? '1' : '0.1';
	}

	public get validationMessage(): string {
		if (isRadar(this.sensorType)) {
			return `${this.nominalLabel} is required and must be a whole number greater than or equal to 0${this.unit}`;
		}
		return `${this.nominalLabel} is required and must be greater than or equal to 0${this.unit} (max 1 decimal place)`;
	}

	public get nameValid(): boolean {
		return this.name.length > 0;
	}

	public get nominalValueValid(): boolean {
		if (typeof this.nominalValue !== 'number' || this.nominalValue < 0) {
			return false;
		}
		if (isRadar(this.sensorType)) {
			return Number.isInteger(this.nominalValue);
		} else {
			return parseFloat(this.nominalValue.toFixed(1)) === this.nominalValue;
		}
	}

	public get canSubmit(): boolean {
		return this.nominalValueValid && this.nameValid;
	}

	public resetForm(): void {
		this.name = '';
		this.nominalValue = 0;
		this.sensorType = 'strain';
	}

	public async onSave(): Promise<void> {
		// Convert tons to kg for strain (1 ton = 1000 kg)
		const nominalWeightInKg = this.nominalValue * 1000;

		const params = isRadar(this.sensorType)
			? { nominalVolume: this.nominalValue, name: this.name, sensorType: 'radar'  }
			: { nominalWeight: nominalWeightInKg, name: this.name, sensorType: 'strain' };

		await this.createFeedTank(params);
		await this.onTankCreated();
		this.resetForm();
	}
}
